import { commonImage } from 'constants/images';
import styled from 'styled-components';

interface StyledMainHeaderProps {
  $isGsChart: boolean;
}

export const StyledMainHeader = styled.header<StyledMainHeaderProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 52px;
  background: var(--main-gradient);

  .mh-left {
    display: flex;
    align-items: center;

    .logo {
      display: flex;
      gap: 10px;

      img {
        width: 100px;
        height: 40px;
        object-fit: contain;
      }
    }
  }

  .mh-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    color: var(--color-white);
    white-space: nowrap;
    cursor: pointer;

    svg {
      width: 190px;
    }

    ${({ $isGsChart }) =>
      $isGsChart &&
      `
    color: var(--color-primary-blue);

     &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -50%);
      width: 644px;
      height: 52px;
      background: url(${commonImage.gsHeader}) center center / contain no-repeat;
      z-index: -1;
    }
   `}
  }

  .mh-right {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: var(--color-white);

    p {
      margin-right: 14px;
      color: var(--color-white);
    }

    button.alarm {
      margin: 0px 4px 0px 5px;
    }
  }

  @media (max-width: 1023px) {
    .mh-right {
      > p {
        display: none;
      }
    }
  }

  ${({ $isGsChart }) =>
    $isGsChart &&
    `
      background: rgba(4, 4, 4, 0.6) !important;
      box-shadow: 0px 0px 11.5px 0px rgba(13, 175, 160, 0.6) inset;
   `}
`;
